<template>
  <div class="add-user" ref="userForm" :class="valid">
    <v-card>
      <v-card-title class="">
        <h3>{{ inputMode }} New User</h3>
      </v-card-title>

      <v-card-text>
        <v-form>
          <label>First Name</label>
          <v-text-field
            outline
            v-model="user.first_name"
            :rules="[(v) => !!v || 'first name is required']"
          >
          </v-text-field>
          <label>Last Name</label>
          <v-text-field
            outline
            v-model="user.last_name"
            :rules="[(v) => !!v || 'last name is required']"
          >
          </v-text-field>
          <label>Email</label>
          <v-text-field
            outline
            v-model="user.email"
            :rules="[
              (v) => !!v || 'email is required',
              (v) => /.+@.+/.test(v) || 'E-mail must be valid',
            ]"
          >
          </v-text-field>
          <label>Confirm Password</label>
          <v-text-field
            outline
            v-model="user.password"
            type="password"
            :rules="[
              (v) => !!v || 'password is required',
              (v) =>
                (v || '').length > 7 ||
                'password should be larger than 7 characters',
            ]"
          >
          </v-text-field>
          <label>Confirm Password</label>
          <v-text-field
            outline
            v-model="confirmPassword"
            type="password"
            :rules="[
              (v) => !!v || 'confirm password',
              (v) => v === user.password || 'password is not match',
            ]"
          >
          </v-text-field>
          <label>Role</label>
          <v-select
            v-model="user.role_id"
            outline
            :items="availableRoles"
            item-text="name"
            item-value="id"
            :rules="[(v) => !!v || 'Role is required']"
          ></v-select>

          <label>Bots</label>
          <v-select
            v-model="user.bots"
            multiple
            outline
            :items="availableBots"
            item-text="title"
            item-value="id"
            :rules="[(v) => !!v || 'Bots is required']"
          ></v-select>

          <label>Reference ID</label>
          <v-text-field outline v-model="user.reference_id"></v-text-field>

          <v-alert :value="error" color="error" icon="warning" outline>
            {{ error }}
          </v-alert>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-btn
          color="primary"
          arge
          round
          @click="addUser"
          v-if="inputMode === 'add'"
          block
        >
          Add
        </v-btn>
        <v-btn
          color="primary"
          arge
          round
          @click="editUser"
          v-if="inputMode === 'edit'"
          block
        >
          Update
        </v-btn>
        <v-btn
          color="primary"
          arge
          round
          flat
          @click="$emit('closeDialog')"
          block
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import _ from "lodash";
import common from "../../utils/common";
export default {
  name: "addOrEdit",
  props: {
    userData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    inputMode: {
      type: String,
      default: () => {
        return "add";
      },
    },
    roles: {
      type: Array,
    },
  },
  computed: {
    availableRoles() {
      return this.roles.filter(
        (role) =>
          role.name !== "Admin" ||
          (role.name === "Admin" && common.isRole("Admin"))
      );
    },
    availableBots() {
      return this.bots;
    },
  },
  data() {
    return {
      valid: false,
      confirmPassword: "",
      user: {
        first_name: "",
        last_name: "",
        email: "",
        password: "",
        role_id: "",
        corporate_id: "",
        reference_id: "",
        bots: [],
      },
      error: "",
      bots: [],
    };
  },
  mounted() {
    this.getUserBots();
  },
  methods: {
    async addUser() {
      this.error = "";
      const response = await this.$http.post("/users/", this.user);

      this.$emit("userAdded", response.data);
      this.$emit("closeDialog");
    },
    async editUser() {
      this.error = "";
      const response = await this.$http.put(
        `/users/${this.user.id}`,
        this.user
      );
      this.$emit("userEdited", response.data);
      this.$emit("closeDialog");
    },
    async getUserBots() {
      const response = await this.$http.get("/bot/my");
      this.bots = response.data;
    },
  },
  watch: {
    userData() {
      this.user = {};
      this.confirmPassword = "";
      this.error = "";
      this.user = _.cloneDeep(this.userData);
      // console.log('user', this.user)
    },
  },
};
</script>

<style lang="scss" scoped>
.v-card__title {
  justify-content: center;
  text-transform: capitalize;
}

.v-card__text {
  width: 80%;
  margin: auto;
}

.v-card__actions {
  flex-direction: column;

  .v-btn {
    max-width: 80%;
  }
}
</style>
